import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { randuBlogService } from "../services/api";

const BlogRanduPostsPage = () => {
  const [data, setData] = useState({ items: [], page: 1, total_pages: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async (page = 1) => {
    setLoading(true);
    try {
      const res = await randuBlogService.listPosts({ page, limit: 20, q: q || undefined });
      if (res.success) setData(res);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(1);
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Randu.app Blog — Yazılar" />
      <div className="card mb-3">
        <div className="card-body d-flex flex-wrap gap-2">
          <input
            className="form-control"
            style={{ maxWidth: 280 }}
            placeholder="Ara…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <button type="button" className="btn btn-primary btn-sm" onClick={() => load(1)}>
            Ara
          </button>
          <Link to="/blog-randu/posts/new" className="btn btn-success btn-sm ms-auto">
            Yeni yazı
          </Link>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          {loading ? (
            <p>Yükleniyor…</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Başlık</th>
                    <th>Durum</th>
                    <th>Aktif</th>
                    <th>Yayın</th>
                  </tr>
                </thead>
                <tbody>
                  {(data.items || []).map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <Link to={`/blog-randu/posts/${row.id}`}>{row.title}</Link>
                      </td>
                      <td>{row.status}</td>
                      <td>{row.is_active ? "Evet" : "Hayır"}</td>
                      <td>{row.published_at ? new Date(row.published_at).toLocaleString("tr-TR") : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="d-flex gap-2 mt-3">
            <button
              type="button"
              className="btn btn-light btn-sm"
              disabled={data.page <= 1}
              onClick={() => load(data.page - 1)}
            >
              Önceki
            </button>
            <span className="align-self-center small text-secondary">
              Sayfa {data.page} / {data.total_pages} — {data.total} kayıt
            </span>
            <button
              type="button"
              className="btn btn-light btn-sm"
              disabled={data.page >= data.total_pages}
              onClick={() => load(data.page + 1)}
            >
              Sonraki
            </button>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default BlogRanduPostsPage;
